<template>
  <div class="chart-wrapper">
    <Bar 
      :chart-data="chartData" 
      :chart-options="mergedOptions" 
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { 
  Chart as ChartJS, 
  Title, 
  Tooltip, 
  Legend, 
  BarElement, 
  CategoryScale, 
  LinearScale 
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: 'Dataset'
    },
    backgroundColor: {
      type: [String, Array],
      default: '#6b20c1'
    },
    borderColor: {
      type: [String, Array],
      default: '#6b20c1'
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    chartOptions: {
      type: Object,
      default: () => ({})
    },
    // Soporte para múltiples datasets
    datasets: {
      type: Array,
      default: null
    }
  },
  computed: {
    chartData() {
      // Si se proporcionan datasets personalizados, usarlos
      if (this.datasets && this.datasets.length > 0) {
        return {
          labels: this.labels,
          datasets: this.datasets.map(dataset => ({
            label: dataset.label || 'Dataset',
            backgroundColor: dataset.backgroundColor || this.backgroundColor,
            borderColor: dataset.borderColor || this.borderColor,
            borderWidth: dataset.borderWidth || 1,
            data: dataset.data || []
          }))
        }
      }
      
      // Dataset simple
      return {
        labels: this.labels,
        datasets: [{
          label: this.label,
          backgroundColor: this.backgroundColor,
          borderColor: this.borderColor,
          borderWidth: 1,
          data: this.data
        }]
      }
    },
    mergedOptions() {
      const defaultOptions = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: this.horizontal ? 'y' : 'x',
        plugins: {
          legend: {
            display: true,
            position: 'top'
          },
          title: {
            display: this.title !== '',
            text: this.title
          }
        },
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
      
      // Merge con las opciones personalizadas del usuario
      return this.deepMerge(defaultOptions, this.chartOptions)
    }
  },
  methods: {
    // Función para hacer merge profundo de objetos
    deepMerge(target, source) {
      const output = Object.assign({}, target)
      if (this.isObject(target) && this.isObject(source)) {
        Object.keys(source).forEach(key => {
          if (this.isObject(source[key])) {
            if (!(key in target)) {
              Object.assign(output, { [key]: source[key] })
            } else {
              output[key] = this.deepMerge(target[key], source[key])
            }
          } else {
            Object.assign(output, { [key]: source[key] })
          }
        })
      }
      return output
    },
    isObject(item) {
      return item && typeof item === 'object' && !Array.isArray(item)
    }
  }
}
</script>

<style scoped>
.chart-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>